import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../common/formInputsV2/styles/tokens';

export const RcQuotesStyles = styled.div`
  margin-bottom: 80px;

  .failed-quotations-block {
    margin-top: 120px;
  }
  .failed-quotations-block img {
    width: 100%;
    display: block;
    aspect-ratio: 6/3;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
`;

export const FailedQuotesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 112px;
  height: 64px;
  padding: 8px;
  border: 1px solid ${v2Colors.disabledSurface};
  border-radius: 12px;
  background: ${v2Colors.inputBackground};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    width: 88px;
    height: 52px;
    padding: 6px;
  }
`;

export const FailedQuoteTitle = styled.h3`
  margin: 0 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${v2Colors.disabledBorder};
  color: ${v2Colors.text};
  font-family: ${v2FontFamily};
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`;

// "Avviso!" — quote failed due to an insurance-data issue, contact the
// backoffice. Replaces the plain Bootstrap `alert alert-info`.
export const AvvisoAlert = styled.div`
  margin: 0 0 16px;
  padding: 14px 18px;
  border: 1px solid ${v2Colors.warningBorder};
  border-radius: 12px;
  background: ${v2Colors.warningSoft};
  font-family: ${v2FontFamily};

  h4 {
    margin: 0 0 6px;
    color: ${v2Colors.warningText};
    font-size: 16px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: ${v2Colors.text};
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const ProdottiCorrelatiText = styled.h2`
  color: var(--common-black, #1a1921);
  font-feature-settings: "clig" off, "liga" off;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  margin-bottom: 0;
`;

export const QuoteLoader = styled.span`
  width: 50px;
  height: 50px;
  background: rgb(0, 166, 81);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
`;

export const ConsulenzaReportButton = styled.div`
  border-radius: 10px;
  background: #00a651;
  border: 1px solid #dff3ea;
  padding: 8px 20px;
  color: #ffffff;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-left: 0;
  display: table;
  transition: all 300ms ease-in-out;
  cursor: pointer;

  &:hover {
    background: transparent;
    border: 1px solid #00a651;
    color: #00a651;
  }

  @media only screen and (max-width: 900px) {
    font-size: 14px;
    padding: 8px 20px;
    border-radius: 10px;
    width: 100%;
  }
`;

export const LambdaLoaderCard = styled.div`
  @keyframes fadeInSlide {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% {
      alpha: 1;
    }
    50% {
      box-shadow: 0 2px 8px rgba(0, 154, 81, 0.2);
    }
  }

  background-color: #ffffff;
  background-image: linear-gradient(135deg, #e8f5e9 0%, #f1f8f6 100%);
  border-radius: 1rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 70px;
  box-shadow: 0 2px 8px rgba(0, 154, 81, 0.1);
  border: 1px solid rgba(0, 154, 81, 0.15);
  animation: fadeInSlide 0.6s ease-out, pulse 2s ease-in-out infinite;
  transition: all 0.3s ease-in-out;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 166, 81, 0.2);
    transform: translateY(-2px);
  }
`;

export const LambdaLoaderSpinner = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  animation: spin 1s linear infinite;
`;

export const LambdaLoaderText = styled.p`
  @keyframes fadeInText {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  margin-bottom: 0;
  font-size: 0.9rem;
  animation: fadeInText 0.8s ease-out;
  color: #666;
`;

export const ProcediButton = styled.button`
  border-radius: 15px;
  background: #00a651;
  border: 1px solid #00a651;
  padding: 10px 45px;
  color: #ffffff;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  transition: all 300ms ease-in-out;
  cursor: pointer;

  &:hover {
    background: transparent;
    border: 1px solid #00a651;
    color: #00a651;
  }

  @media only screen and (min-width: 1401px) {
    font-size: 1.15rem;
  }

  @media only screen and (max-width: 1400px) {
    font-size: 0.875rem;
    padding: 8px 40px;
    border-radius: 10px;
  }
`;

export const ModificaGaranzieButton = styled.button`
  border-radius: 15px;
  background: transparent;
  border: 1px solid #1a1921;
  padding: 10px 30px;
  color: #1a1921;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 300ms ease-in-out;
  cursor: pointer;

  img {
    max-width: 18px;
    filter: brightness(0);
  }

  &:hover {
    background: #1a1921;
    color: #ffffff;

    img {
      filter: brightness(0) invert(1);
    }
  }

  @media only screen and (min-width: 1401px) {
    font-size: 1.15rem;
  }

  @media only screen and (max-width: 1400px) {
    font-size: 0.875rem;
    padding: 8px 25px;
    border-radius: 10px;
  }
`;
